import * as React from 'react';
import { clsx } from 'clsx';
import { SingleSelectItem } from '../../../internal';
import styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export function GroupedSelectMobileOptions(props) {
  const {
    indented,
    options,
    value,
    onChange
  } = props;
  return /*#__PURE__*/_jsx("div", {
    className: styles['list'],
    children: options.map(option => {
      const optionValue = option.value;
      const key = String(optionValue);
      const selected = value === optionValue;
      return /*#__PURE__*/_jsx("div", {
        className: clsx(styles['item-wrapper'], indented && styles['indented']),
        children: /*#__PURE__*/_jsx("div", {
          className: styles['item'],
          children: /*#__PURE__*/_jsx(SingleSelectItem, {
            option: option,
            selected: selected,
            onClick: () => {
              onChange(optionValue);
            },
            role: "option",
            "aria-selected": selected ? 'true' : undefined
          })
        })
      }, key);
    })
  });
}